




























































































import { Component, Watch } from 'vue-property-decorator';
import { helpers, requiredIf, minLength } from 'vuelidate/lib/validators';
import { RuleDecl } from 'vue/types/options';
import { State } from 'vuex-class';
import Location from '@/services/Location';
import states from '@/services/states';
import Vue from 'vue';

import ContactNumbers from './ContactNumbers.vue';

const zip = helpers.regex('zip', /^\d{5}(-\d{4})?$/);
const addressReqMsg = 'Please complete this field';
const mailAddressCheck = function(loc: Location) {
	return (
		loc.mailAddress1 ||
		loc.mailAddress2 ||
		loc.mailCity ||
		loc.mailState ||
		loc.mailZip
	)
}

@Component({
	components: { 
		ContactNumbers,
	}
})

export default class Contact extends Vue {
	@State('location') location!: Location;

	@Watch('location.mailSameAsPhysical') 
	handleMailAddress(value: boolean) {
		if (value) {
			this.location.mailAddress1 = this.location.address1;
			this.location.mailAddress2 = this.location.address2;
			this.location.mailCity = this.location.city;
			this.location.mailState = this.location.state;
			this.location.mailZip = this.location.zip;
		}
	}

	states = states;
	uniquePhone(val: string, f: string) {
		return this.location.phones.filter(x => x[f].toLowerCase() == val.toLowerCase()).length == 1
	}

	validations(): RuleDecl {
		return {
			location: {
				mailSameAsPhysical: {
				},
				mailAddress1: {
					required: requiredIf((model) => {
						return mailAddressCheck(model)
					})
				},
				mailAddress2: {
				},
				mailCity: {
					required: requiredIf((model) => {
						return mailAddressCheck(model)
					})
				},
				mailState: {
					required: requiredIf((model) => {
						return mailAddressCheck(model)
					}),
					minLength: minLength(2)
				},
				mailZip: {
					required: requiredIf((model) => {
						return mailAddressCheck(model)
					}),
					zip: zip
				},
				phones: {
					$each: {
						name: {
							required: requiredIf((model) => {
								return model.value;
							}),
							isUnique: (name) => {
								return !name.length || this.uniquePhone(name, 'name');
							}
						},
						value: {
							required: requiredIf((model) => {
								return model.name;
							}),
							isUnique: (value) => {
								return !value.length || this.uniquePhone(value, 'value');
							}
						},
					}
				}
			}
		}
	}

	isMounted = false;

	mounted(): void {
		this.isMounted = true;
	}

	touch(): void {
		this.$v.location.phones?.$touch();
	}

	reset(): void {
		this.$v.location.phones?.$reset();
	}
	
	get isDirty(): boolean {
		return this.$v.location.phones?.$anyDirty || false;
	}

	get hasErrors(): boolean {
		if (!this.isMounted) {
			return false;
		}

		return this.phonesError
			|| this.$v.location.mailAddress1?.$invalid
			|| this.$v.location.mailCity?.$invalid
			|| this.$v.location.mailState?.$invalid
			|| this.$v.location.mailZip?.$invalid
			|| false
	}

	get phonesError(): boolean {
		return this.isMounted && this.$v.location.phones?.$anyError || false;
	}

	get mailAddress1Errors() {
		if (this.$v.location.mailAddress1?.$invalid) {
			return addressReqMsg
		}
		return [];
	}

	get mailCityErrors() {
		if (this.$v.location.mailCity?.$invalid) {
			return addressReqMsg
		}
		return [];
	}

	get mailStateErrors() {
		if (this.$v.location.mailState?.$invalid) {
			return addressReqMsg
		}
		return [];
	}

	get mailZipErrors() {
		if (this.$v.location.mailZip?.$anyError || this.$v.location.mailZip?.$invalid) {
			if (!this.$v.location.mailZip?.zip) {
				return 'Zip or Zip +4 is accepted.'
			}
			return addressReqMsg
		} 
		return [];
	}

}
